/* eslint-disable no-undef */
/* eslint-disable func-names */
import { replaceSvg } from "./helpers/helpers";
import accordion from "./ui/accordion";
import awardsDropdown from "./ui/awards-dropdown";
import burger from "./ui/burger";
import cookie from "./ui/cookie";
import counters from "./ui/counters";
import hardWork from "./ui/hard-work";
import heroTabs from "./ui/hero-tabs";
import languages from "./ui/languages";
import latestNews from "./ui/latest-news";
import locationTabs from "./ui/location-tabs";
import modal from "./ui/modal";
import navigation from "./ui/nav";
import newsFilter from "./ui/news-filter";
import scrollTo from "./ui/scroll-to";
import searchBar from "./ui/search-bar";
// import searchResults from './ui/search-results';
import services from "./ui/services";
import stickyBar from "./ui/sticky-bar";
import teamCard from "./ui/team-card";
import teamFilter from "./ui/team-filter";
import video from "./ui/video";
import videoLoader from "./ui/videoLoader";
import share from "./ui/social-share";
import lazyLoad from "./ui/lazy-load";
import featuredNews from "./ui/featured-news";
import relatedNews from "./ui/related-news";

(function ($) {
  $(document).ready(() => {
    videoLoader();
    lazyLoad();

    accordion();
    cookie();
    counters();
    replaceSvg();
    awardsDropdown();
    burger();
    featuredNews();
    relatedNews();
    hardWork();
    heroTabs();
    languages();
    latestNews();
    locationTabs();
    modal();
    navigation();
    newsFilter();
    scrollTo();
    searchBar();
    // searchResults();
    services();
    stickyBar();
    teamCard();
    teamFilter();
    video();
    share();
  });
})(jQuery);
